import { IsEmail, IsNotEmpty, IsOptional, IsString } from 'class-validator';

export class ContactInfosDto {
  @IsEmail()
  @IsNotEmpty()
  email!: string;

  @IsOptional()
  @IsString()
  mobileNumber?: string;
}
